export default __webpack_public_path__ + "static/media/wells-chan-H-vAxuWxmi8-unsplash.40d966e7.jpg";